import { atom } from 'recoil';

export const userFilterAtom = atom({
  key: 'userFilterAtom',
  default: {
    name: '',
    email: '',
  },
});
